import { ExclamationIcon } from '@heroicons/react/outline';
import styles from './Error.module.css';

export default function Error({
  errorMsg,
  errorTitle,
  actionBtn,
  style,
  icon,
  display,
}: {
  errorMsg: string;
  errorTitle?: string;
  actionBtn?: JSX.Element;
  style?: 'plain' | 'card';
  display?: 'row' | 'col';
  icon?: boolean;
}) {
  return (
    <>
      <div
        className={`${style ? styles[style] : styles['plain']} ${
          display ? styles[display] : styles['row']
        }`}
      >
        {icon && (
          <span className="bg-red-100 rounded-full p-2">
            <ExclamationIcon className="lg:h-6 lg:w-6 text-tertiaryColor-normal" />
          </span>
        )}
        <div className="flex flex-col justify-center">
          {errorTitle && (
            <h2 className="m-0 font-bold text-center lg:text-left">
              {errorTitle}
            </h2>
          )}
          <p className="mb-5 mt-2">{errorMsg}</p>
          {actionBtn && <div>{actionBtn}</div>}
        </div>
      </div>
    </>
  );
}
